// Strips everything that shouldn't end up in Redux (and therefore, via redux-persist, in
// localStorage): supplier/survey business data, and the access+refresh JWTs and trusted-device
// token — nothing in the app reads these from Redux state, only from the cookies setSession()
// sets, so persisting a plaintext copy here would just be pointless exposure.
export const getSanitizedResponse = (userResponse) => {
    const sanitizedResponse = { ...userResponse, user: { ...userResponse.user } };
    delete sanitizedResponse.user.suppliers;
    delete sanitizedResponse.user.surveys;
    delete sanitizedResponse.tokens;
    delete sanitizedResponse.deviceToken;
    return sanitizedResponse;
};
